import * as CONSTANTS from './constants';

export const acceptOrDeclineJobRequest = ({
  id,
  payload,
  callBack = () => {},
  onError = () => {}
}) => ({
  type: CONSTANTS.ACCEPT_OR_DECLINE_JOB_REQUEST,
  id,
  payload,
  callBack,
  onError
});

export const acceptOrDeclineJobSuccess = (data) => ({
  type: CONSTANTS.ACCEPT_OR_DECLINE_JOB_SUCCESS,
  data
});

export const acceptOrDeclineJobFail = (error) => ({
  type: CONSTANTS.ACCEPT_OR_DECLINE_JOB_FAIL,
  error
});

export const acceptOrDeclineJobReset = () => ({
  type: CONSTANTS.ACCEPT_OR_DECLINE_JOB_RESET
});

export const cancelJobRequest = ({ id, payload }) => ({
  type: CONSTANTS.CANCEL_JOB_REQUEST,
  id,
  payload
});

export const cancelJobSuccess = (data) => ({
  type: CONSTANTS.CANCEL_JOB_SUCCESS,
  data
});

export const cancelJobFail = (error) => ({
  type: CONSTANTS.CANCEL_JOB_FAIL,
  error
});

// TODO: Replace filter with separate endpoints
export const fetchContractorJobsRequest = (contractorId, filter) => ({
  type: CONSTANTS.FETCH_CONTRACTOR_JOBS_REQUEST,
  contractorId,
  filter
});

export const fetchContractorJobsSuccess = (data) => ({
  type: CONSTANTS.FETCH_CONTRACTOR_JOBS_SUCCESS,
  data
});

export const fetchContractorJobsFail = (error) => ({
  type: CONSTANTS.FETCH_CONTRACTOR_JOBS_FAIL,
  error
});

export const fetchContractorJobDetailRequest = (id) => ({
  type: CONSTANTS.FETCH_CONTRACTOR_JOB_DETAIL_REQUEST,
  id
});

export const fetchContractorJobDetailSuccess = (data) => ({
  type: CONSTANTS.FETCH_CONTRACTOR_JOB_DETAIL_SUCCESS,
  data
});

export const fetchContractorJobDetailFail = (error) => ({
  type: CONSTANTS.FETCH_CONTRACTOR_JOB_DETAIL_FAIL,
  error
});

export const updateContractorJobRequest = (
  jobId,
  payload,
  callBack,
  onError
) => ({
  type: CONSTANTS.UPDATE_CONTRACTOR_JOB_REQUEST,
  jobId,
  payload,
  callBack,
  onError
});

export const updateContractorJobSuccess = (data) => ({
  type: CONSTANTS.UPDATE_CONTRACTOR_JOB_SUCCESS,
  data
});

export const updateContractorJobFail = (error) => ({
  type: CONSTANTS.UPDATE_CONTRACTOR_JOB_FAIL,
  error
});

export const deleteBulkContractorJobRequest = (jobIds, callBack, onError) => ({
  type: CONSTANTS.DELETE_BULK_CONTRACTOR_JOB_REQUEST,
  jobIds,
  callBack,
  onError
});

export const deleteBulkContractorJobSuccess = (data) => ({
  type: CONSTANTS.DELETE_BULK_CONTRACTOR_JOB_SUCCESS,
  data
});

export const deleteBulkContractorJobFail = (error) => ({
  type: CONSTANTS.DELETE_BULK_CONTRACTOR_JOB_FAIL,
  error
});

export const archiveMemoRequest = ({
  memoId,
  callBack = () => {},
  onError = () => {}
}) => ({
  type: CONSTANTS.ARCHIVE_MEMO_REQUEST,
  memoId,
  callBack,
  onError
});

export const archiveMemoSuccess = (data) => ({
  type: CONSTANTS.ARCHIVE_MEMO_SUCCESS,
  data
});

export const archiveMemoFail = (error) => ({
  type: CONSTANTS.ARCHIVE_MEMO_FAIL,
  error
});

export const deleteJobRequest = (jobMemoId) => ({
  type: CONSTANTS.DELETE_SINGLE_JOB_MEMO_REQUEST,
  jobMemoId
});

export const deleteJobSuccess = (payload) => ({
  type: CONSTANTS.DELETE_SINGLE_JOB_MEMO_SUCCESS,
  payload
});

export const deleteJobFail = (error) => ({
  type: CONSTANTS.DELETE_SINGLE_JOB_MEMO_FAIL,
  error
});

export const fetchArchivedMemoRequest = (contractorId) => ({
  type: CONSTANTS.FETCH_ARCHIVED_MEMO_REQUEST,
  contractorId
});

export const fetchArchivedMemoSuccess = (data) => ({
  type: CONSTANTS.FETCH_ARCHIVED_MEMO_SUCCESS,
  payload: data
});

export const fetchArchivedMemoFail = (error) => ({
  type: CONSTANTS.FETCH_ARCHIVED_MEMO_FAIL,
  error
});

export const deleteBulkArchivedMemoRequest = (jobIds, callBack, onError) => ({
  type: CONSTANTS.DELETE_BULK_ARCHIVED_MEMO_REQUEST,
  jobIds,
  callBack,
  onError
});

export const deleteBulkArchivedMemoSuccess = (data) => ({
  type: CONSTANTS.DELETE_BULK_ARCHIVED_MEMO_SUCCESS,
  data
});

export const deleteBulkArchivedMemoFail = (error) => ({
  type: CONSTANTS.DELETE_BULK_ARCHIVED_MEMO_FAIL,
  error
});

export const fetchDeclinedMemoRequest = (contractorId) => ({
  type: CONSTANTS.FETCH_DECLINED_MEMO_REQUEST,
  contractorId
});

export const fetchDeclinedMemoSuccess = (data) => ({
  type: CONSTANTS.FETCH_DECLINED_MEMO_SUCCESS,
  payload: data
});

export const fetchDeclinedMemoFail = (error) => ({
  type: CONSTANTS.FETCH_DECLINED_MEMO_FAIL,
  error
});

export const deleteBulkDeclinedMemoRequest = (jobIds, callBack, onError) => ({
  type: CONSTANTS.DELETE_BULK_DECLINED_MEMO_REQUEST,
  jobIds,
  callBack,
  onError
});

export const deleteBulkDeclinedMemoSuccess = (data) => ({
  type: CONSTANTS.DELETE_BULK_DECLINED_MEMO_SUCCESS,
  data
});

export const deleteBulkDeclinedMemoFail = (error) => ({
  type: CONSTANTS.DELETE_BULK_DECLINED_MEMO_FAIL,
  error
});

export const fetchFreelancerJobCounter = () => ({
  type: CONSTANTS.FETCH_JOB_COUNTER_REQUEST,
});

export const fetchFreelancerJobCounterSuccess = (data) => ({
  type: CONSTANTS.FETCH_JOB_COUNTER_SUCCESS,
  data,
});

export const fetchFreelancerJobCounterFail = (error) => ({
  type: CONSTANTS.FETCH_JOB_COUNTER_FAIL,
  error,
});
